<template>
  <div class="left">
  	<div class="computer" @click="handleShowComputer" style="cursor: pointer;">
  		<img src="../assets/img/computer.png" width="18" height="20">
  		<span style="font-size: 20px;margin-left: 10px;">计算器</span>
  	</div>
  	<div class="card">
  		答题卡
  	</div>
  	<div class="list">
  		<span class="" :class="{'right':item.answerStatus==1,'error':item.answerStatus==0,'active':activeIndex==item.index}" v-for="item,index in activeList" @click="handleTabIndex(item.index)">{{item.index}}</span>
  		<span class="noborder" v-for="item in 5-activeList.length%5"></span>
  	</div>
  	<div class="tag flex">
  		<span class="right"></span>
  		<span class="font14">正确</span>
  		<span class="error"></span>
  		<span class="font14">错误</span>
  		<span class="nodo"></span>
  		<span class="font14">未答</span>
  	</div>
  	<div class="pages text-center" style="font-size: 18px;">
  		<span style="color: #4fa7ff;">{{pageNumber}}</span>/{{totalPage}}
  	</div>
  	<div class="btnwrap">
  		<span class="btn" @click="handlePerv()">上一页</span>
  		<span class="btn" @click="handleNext()">下一页</span>
  	</div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    props:{
      list:{
          type:Array,
          default:()=>[],
      },
      activeIndex:{
          type:Number,
          default:()=>1,
      }
    },
    data () {
      return {
          data:'',
          pageSize:40,
          pageNumber:0,
          totalPage:1,
          activeList:[]
      }
    },
    methods:{
      handleShowComputer(){
        this.$emit('handleShowComputer')
      },
      handlePerv(){  //上一页
        if(this.pageNumber>1){
          this.pageNumber--;
        }
      },
      handleNext(){  //下一页
        if(this.pageNumber<this.totalPage){
          this.pageNumber++
        }
      },
      handleTabIndex(index){
        this.$emit('tabIndex',index)
      }
    },
    created(){

    },
    watch:{
      pageNumber(val){

        this.activeList=this.list.slice((val-1)*this.pageSize,(val)*this.pageSize)
      },
      list(val){
        // console.log(val.length)
        this.totalPage=Math.ceil(this.list.length/this.pageSize);
        this.pageNumber=1;
        this.activeList=this.list.slice(0,45)
      }
    },

  }
</script>

<style scoped>
  .left {
  	width: 300px;
  }
  .computer {
  	text-align: center;
  	height: 60px;
  	line-height: 60px;
  	border: 1px solid silver;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  	font-weight: bold;
    background-color: #fff;
  }
  .card {
  	text-align: center;
  	height: 60px;
  	line-height: 60px;
  	border: 1px solid silver;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  	font-size: 20px;
  	margin-top: 20px;
  	font-weight: bold;
  }
  .list {
  	display: flex;
  	flex-wrap: wrap;
  	justify-content: space-between;
  	padding: 0 15px;
  	border: 1px solid silver;
  	border-top: none;
  	border-bottom: none;
    height: 608px;
    align-content: baseline;
  }
  .list span {
  	width: 44px;
  	height: 44px;
  	border-radius: 5px;
  	border: 1px solid #4fa7ff;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  	margin-top: 15px;
  	color: #4fa7ff;
    cursor: pointer;

  }
  .list span.active {
    color: #FFFFFF;
        background-color: #4fa7ff;
        border-color: #4fa7ff;
  }
  .list span.right {
  	color: #fff;
  	background-color: #03DD6D;
  	border-color: #03DD6D;
  }
  .list span.error {
  	color: #fff;
  	background-color: #FD2744;
  	border-color: #FD2744;

  }
  .list span.noborder {
  	border: none;
  }
  .tag {
  	border: 1px solid silver;
  	padding: 15px;
  	border-top: none;
  	border-bottom: none;
  	display: flex;
  	align-items: center;
  }
  .tag .right {
  	color: #03DD6D;
  	background-color: #03DD6D;
  	border-color: #03DD6D;
  	width: 16px;
  	height: 16px;
  	border-radius: 4px;
  	margin-right: 5px;

  }
  .tag .error {
  	color: #FD2744;
  	background-color: #FD2744;
  	border-color: #FD2744;
  	width: 16px;
  	height: 16px;
  	border-radius: 4px;
  	margin-right: 5px;
  	margin-left: 5px;
  }
  .tag .nodo {
  	width: 16px;
  	height: 16px;
  	border-radius: 5px;
  	border: 1px solid #4fa7ff;
  	align-items: center;
  	justify-content: center;
  	margin-right: 5px;
  	margin-left: 5px;

  }
  .pages {
  	border: 1px solid silver;
  	padding:30px 15px 30px 15px;
  	border-top: none;

  }
  .btnwrap {
  	background-color: #4d5158;
  	color: #fff;
  	height: 40px;
  	line-height: 40px;
  	display: flex;
  }
  .btn {
  	width: 50%;
  	text-align: center;
  	color: #fff;
    cursor: pointer;

  }
</style>



// WEBPACK FOOTER //
// src/components/testleft.vue